import React, { useState } from 'react';

import { Button, Stack, TextField } from '@mui/material';

import { INVALID_HANDLING_FEE_MESSAGE, parseHandlingFee } from './pnrImport';

interface Props {
  /** Names the field, like "Handling fee for all seats". */
  label: string;
  /** Names the button, like "Apply to all seats". */
  buttonLabel: string;
  onApply: (fee: string) => void;
  disabled?: boolean;
}

export default function PnrImportApplyFeeToAll({ label, buttonLabel, onApply, disabled }: Props) {
  const [fee, setFee] = useState('');
  const hasInvalidFee = parseHandlingFee(fee) === undefined;
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <TextField
        size="small"
        type="number"
        label={label}
        value={fee}
        onChange={(event) => setFee(event.target.value)}
        slotProps={{ htmlInput: { min: 0, step: 0.01 } }}
        error={hasInvalidFee}
        helperText={hasInvalidFee && INVALID_HANDLING_FEE_MESSAGE}
        disabled={disabled}
        sx={{ maxWidth: 260 }}
      />
      <Button variant="text" onClick={() => onApply(fee)} disabled={disabled || hasInvalidFee}>
        {buttonLabel}
      </Button>
    </Stack>
  );
}
